import React from 'react';
import PropTypes from 'prop-types';
import { Expand } from '@sparefoot/react-core';
import { withShowHide } from '@sparefoot/react-core/decorators';

import { Button } from 'components/core/Button';
import { Card } from 'components/legacy/Card';
import { ReviewList } from 'components/molecules/review/ReviewList';
import { ReviewForm } from 'components/review/ReviewForm';

import './FacilityReviews.scss';

export const enhance = withShowHide('reviewForm');

export function FacilityReviews({
	reviews,
	facility,
	reviewPageNum,
	baseUrl,
	onCreateReview,
	source,
	onToggleReviewForm,
	reviewFormShowing,
}) {
	return (
		<Card className="facility-reviews">
			{!reviews.length && (
				<div className="no-reviews">
					There are no reviews for this facility.
				</div>
			)}
			<ReviewList
				reviews={reviews}
				facility={facility}
				currentPage={reviewPageNum}
				baseUrl={baseUrl}
			/>
			<div
				className="review-form-wrapper"
				id="leave-a-review"
			>
				<Button
					secondary
					className="toggle-review-form"
					onClick={onToggleReviewForm}
				>
					Leave a review of this facility
				</Button>
				<Expand showing={reviewFormShowing}>
					<div>
						<ReviewForm
							onSubmit={onCreateReview}
							source={source}
							facilityId={facility.id}
						/>
					</div>
				</Expand>
			</div>
		</Card>
	);
}

FacilityReviews.propTypes = {
	reviews: PropTypes.arrayOf(PropTypes.object),
	facility: PropTypes.object.isRequired,
	reviewPageNum: PropTypes.number,
	baseUrl: PropTypes.string,
	onCreateReview: PropTypes.func,
	onToggleReviewForm: PropTypes.func,
	reviewFormShowing: PropTypes.bool,
	source: PropTypes.string,
};

FacilityReviews.defaultProps = {
	reviews: [],
};

export default enhance(FacilityReviews);
